import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { components } from "react-select";
import makeAnimated from "react-select/animated";
import { ReactHookFormSelect } from "../../../utils";
import MySelect from "./MySelect.js";

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: "100%",
  },
  controler: {
    width: "100rem",
  },
}));

const animatedComponents = makeAnimated();

export default function FormOnUsers(props) {
  const classes = useStyles();
  const {
    open,
    handleClose,
    fetchAPI,
    MultipleHandleOptions,
    stateOption,
  } = props;

  const { handleSubmit, errors, control, clearErrors } = useForm();
  const [addChange, setAddChange] = useState({
    idlayanan: "",
    idrole: "",
  });
  const { idlayanan, idrole } = addChange;
  const [optionSelected, setOptionSelected] = useState([]);

  const groupRole =
    stateOption.optionResult &&
    stateOption.optionResult.map((row) => ({
      value: row.id,
      label: row.nama_user,
      username: row.username,
    }));

  const reset = () => {
    setAddChange({
      ...addChange,
      idrole: "",
      idlayanan: "",
    });
    setOptionSelected([]);
    clearErrors()
  };

  const onSubmit = async () => {
    const data = ({
      ...addChange,
      idrole: idrole,
      idlayanan: idlayanan,
      iduser: optionSelected,
    })
    const result = await fetchAPI("add", data);
    if (result.status === "success") {
      reset();
    }
    return result
  };

  const handleChange = (selected) => {
    setOptionSelected(selected);
  };

  useEffect(() => {
    MultipleHandleOptions({
      type: "usertorole", params: {
        idlayanan,
        idrole,
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idlayanan, idrole]);


  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label>&nbsp;&nbsp;{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          reset();
          handleClose();
        }}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Add On Users to Role</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                xl={12}
                className={classes.controler}
              >
                <ReactHookFormSelect
                  id="idlayanan"
                  name="idlayanan"
                  className={classes.textField}
                  label="ID Layanan"
                  control={control}
                  error={errors.idlayanan}
                  value={idlayanan}
                  // handleOption={handleOption}
                  // handleChange={handleChange}
                  // rules={{
                  //   required: {
                  //     value: true,
                  //     message: `ID layanan tidak boleh kosong`,
                  //   },
                  // }}
                  setState={setAddChange}
                  state={addChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Layanan--
                  </MenuItem>
                  {stateOption.option1 &&
                    stateOption.option1.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </ReactHookFormSelect>
                {errors.idlayanan && (
                  <Typography variant="caption" color="error">
                    {errors.idlayanan.message}
                  </Typography>
                )}
                <ReactHookFormSelect
                  id="idrole"
                  name="idrole"
                  className={classes.textField}
                  label="ID Role"
                  control={control}
                  error={errors.id}
                  value={idrole}
                  // handleOption={handleOption}
                  // handleChange={handleChange}
                  // rules={{
                  //   required: {
                  //     value: true,
                  //     message: `ID Role tidak boleh kosong`,
                  //   },
                  // }}
                  setState={setAddChange}
                  state={addChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Role--
                  </MenuItem>
                  {stateOption.option2 &&
                    stateOption.option2.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </ReactHookFormSelect>
                {errors.idrole && (
                  <Typography variant="caption" color="error">
                    {errors.idrole.message}
                  </Typography>
                )}

                {stateOption && stateOption.optionResult ? (
                  <Grid style={{ height: "25rem" }}>
                    <MySelect
                      options={groupRole}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ Option, MultiValue, animatedComponents }}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={optionSelected}
                    />
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Add
            </Button>
            <Button
              onClick={() => {
                reset();
                handleClose();
              }}
              color="secondary"
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
